import { render, staticRenderFns } from "./EditNotificacionPage.vue?vue&type=template&id=422ad656"
import script from "./EditNotificacionPage.vue?vue&type=script&lang=js"
export * from "./EditNotificacionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports